
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 24a12.01 12.01 0 01-3-.38.5.5 0 01-.37-.52 2.95 2.95 0 00-4.56-2.62.5.5 0 01-.63-.07A12.03 12.03 0 011.61 18a12 12 0 01-1.17-2.8.5.5 0 01.25-.57 2.93 2.93 0 001.47-1.72 2.92 2.92 0 00-.18-2.25A2.93 2.93 0 00.7 9.37a.5.5 0 01-.25-.58 12.02 12.02 0 013-5.2.5.5 0 01.63-.06 2.95 2.95 0 002.22.4A2.95 2.95 0 008.62.9.5.5 0 019 .4a12.03 12.03 0 016 0 .5.5 0 01.38.51 2.93 2.93 0 00.75 2.13 2.95 2.95 0 003.8.5.5.5 0 01.63.07 12.1 12.1 0 013 5.2.5.5 0 01-.25.57 2.95 2.95 0 000 5.26.5.5 0 01.25.58 12.02 12.02 0 01-3 5.2.5.5 0 01-.63.07 2.95 2.95 0 00-4.55 2.63.5.5 0 01-.38.51 12 12 0 01-3 .38zm-2.38-1.26a11 11 0 004.76 0 3.95 3.95 0 015.73-3.31 11.03 11.03 0 002.38-4.12 3.95 3.95 0 010-6.62 11.14 11.14 0 00-2.38-4.12 3.94 3.94 0 01-2 .42 3.92 3.92 0 01-2.73-1.3 3.92 3.92 0 01-1-2.43 10.97 10.97 0 00-4.77 0A3.91 3.91 0 019 3.2a3.92 3.92 0 01-2.5 1.71 3.9 3.9 0 01-2.6-.34 11.01 11.01 0 00-2.4 4.12 3.93 3.93 0 011.36 1.52 3.93 3.93 0 01.24 3.01 3.92 3.92 0 01-1.6 2.09 11.01 11.01 0 00.97 2.19 11.09 11.09 0 001.4 1.93 3.95 3.95 0 015.74 3.3zm2.38-6.8A3.95 3.95 0 1115.95 12 3.95 3.95 0 0112 15.95zm0-6.9A2.95 2.95 0 1014.95 12 2.95 2.95 0 0012 9.05z"}})])
          )
        }
      }
    